// --------------------------------------------------------
// REGISTER ALLERGY - RegisterAllergy
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import React, { useEffect, useState } from 'react'
import { useAppDispatch } from '../../../..';
import ContainerWithSidebar from '../../../../components/UI/containerWithSidebar/ContainerWithSidebar';
import { GeneralContainer, H1 } from '../../../../components/UI/generalLayout/Layout.styled';
import { Spacer } from '../../../../components/UI/spacer/spacer';
import Colors from '../../../../constants/Colors';
import { handleBackendErrors } from '../../../../helpers/HelperFunctions';
import { Button } from '../../../company/companyRegister/CompanyRegister.styled';
import { ModalAllergiesTextCardContainer, ModalAllergiesButtonsContainer } from './components/modalAllergies/ModalAllergies.styled';
import ModalDropdown from './components/modalDropdown/ModalDropdown';
import * as Allergies from "../../../../store/actions/allergies";
import { useLocation, useNavigate } from 'react-router-dom';
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useSelector } from 'react-redux';
import { Paths } from '../../../../enums/Paths';
import ErrorArea from '../../../../components/error/ErrorArea';


// --------------------------------------------------------
// REGISTER ALLERGY INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */
function RegisterAllergy(): JSX.Element {
  // --------------------------------------------------------
  // REGISTER ALLERGY PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [generalErrors, setGeneralErrors] = useState<any[]>([]);
  const [addNewAlergia, setAddNewAlergia] = useState(false);
  const { state }: any = useLocation();
  const { pessoa, allergies } = !!state ? state : { pessoa: { idPessoa: '', nome: '' }, allergies: [] };

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [listAllergiesDropdown, setListAllergiesDropdown] = useState<any>([
    { alergeno: {} },
  ]);

  const typesAllergies: [] = useSelector((state: any) => state.allergies.types) ?? [];

  const onNavigateToProntuario = () => {
    navigate(Paths.Prontuario, { state: { pessoa: pessoa } })
  }

  const clearList = () => {
    setListAllergiesDropdown((prev: any) => {
      const list = [...prev];
      const removedElement: any[] = list.splice(list.length, 0);
      removedElement.push({ alergeno: {} });
      return removedElement;
    });
  };

  const verifyList = () => {
    for (const item of listAllergiesDropdown) {
      const alergia = item.alergeno.alergeno;
      if (alergia === undefined || alergia === "") {
        setAddNewAlergia(false);
        return;
      } else {
        setAddNewAlergia(true);
      }
    }
  };

  // Função de salvar as alergias
  const saveAlergia = async () => {
    try {
      const list = [];

      for (const item of listAllergiesDropdown) {
        const id: any = item.alergeno.id;
        const idPessoa = pessoa.idPessoa;

        if (
          item.alergeno.alergeno !== undefined &&
          item.alergeno.alergeno !== ""
        ) {
          list.push({ alergiaId: id, pessoaId: idPessoa });
        }
      }
      await dispatch(Allergies.registerAllergieInPerson(list));
      clearList();
      onNavigateToProntuario();
    } catch (error: any) {
      handleBackendErrors(error, setGeneralErrors);
    }
  };

  useEffect(() => {
    verifyList();
  }, [listAllergiesDropdown]);

  return <ContainerWithSidebar>
    <GeneralContainer>
      <div>
        <div>
          <ModalAllergiesTextCardContainer>
            <H1
              style={{
                fontSize: "28px",
              }}
              color={Colors.SPM600}
            >
              Registro de Alergia
            </H1>
            <ErrorArea errorList={generalErrors} onCloseAction={() => { setGeneralErrors([]) }} />
          </ModalAllergiesTextCardContainer>
          <Spacer bottom={10} />
          <div>
            {listAllergiesDropdown.map((d: any, index: number) => (
              <ModalDropdown
                List={listAllergiesDropdown}
                key={index}
                myAllergies={allergies}
                addAllergies={setListAllergiesDropdown}
                tipos={typesAllergies}
                response={d}
                responseIndex={index}
                setGeneralErrors={setGeneralErrors}
              />
            ))}
          </div>
          <Spacer bottom={40} />

          <Button
            onClick={() => {
              setListAllergiesDropdown((prev: any) => {
                const list = [...prev];
                list.push({ alergeno: {} });
                return list;
              });
            }}
            disabled={!addNewAlergia}
            color={Colors.lightBlue}
            backgroundColor={Colors.WHITE}
            borderColor={Colors.lightBlue}
          >
            <AddCircleOutlineIcon />
            Adicionar outra alergia
          </Button>
          <Spacer bottom={30} />
          <ModalAllergiesButtonsContainer>
            <Button
              onClick={() => {
                clearList();
                onNavigateToProntuario();
              }}
              color={Colors.lightBlue}
              backgroundColor={Colors.WHITE}
              borderColor={Colors.lightBlue}
            >
              Voltar
            </Button>
            <Button
              onClick={() => {
                saveAlergia();
              }}
              color={Colors.WHITE}
              backgroundColor={Colors.SPM600}
              disabled={!addNewAlergia}
            >
              Salvar alergia
            </Button>
          </ModalAllergiesButtonsContainer>
        </div>
      </div>
    </GeneralContainer>
  </ContainerWithSidebar>;
}

export default RegisterAllergy;
